import { EventName } from '@lit/react';
import { BlocksRadioField } from 'blocks-nextjs/blocks-web-components/components/radio-field/radio-field';
import { BlocksRadioChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatRadioField = createComponent({
  react: React,
  tagName: 'cat-radio-field',
  elementClass: BlocksRadioField,
  events: {
    onBlRadioChange: 'bl-radio-change' as EventName<BlocksRadioChangeEvent>
  }
});
